module.exports = __webpack_public_path__ + "img/ep-biche.df094006.png";